import React from 'react';
import { PageModel } from './models';
import { SortButton } from '../../search/components/sort';

interface Props {
	pageModel: PageModel,
}

export function ListViewSorts(props: Props) {
	const { pageModel } = props;
	return (
		<div className='topic-list topic-list-sort'>
			{
				pageModel?.hideDatesAndCategories !== 'True' &&
				<div className='topic-list-cell'>
					<SortButton label={pageModel?.dateLabel} name='dateCompare' />
				</div>
			}
			<div className='topic-list-cell topic-list-cell-large'>
				<SortButton label={pageModel?.titleLabel} name='articleTitle' />
			</div>
			{
				pageModel?.hideDatesAndCategories !== 'True' &&
				<div className='topic-list-cell'>
					<SortButton label={pageModel?.categoryLabel} name='category' />
				</div>
			}
			<div className='topic-list-cell'>
				<SortButton label={pageModel?.typeLabel} name='articleType' />
			</div>
		</div>
	);
}